/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Records_TitleInputs */

const en_us2_workout_after_records_title = /** @type {(inputs: Workout_After_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New personal bests`)
};

const pt_br2_workout_after_records_title = /** @type {(inputs: Workout_After_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos recordes pessoais`)
};

const es_419_workout_after_records_title = /** @type {(inputs: Workout_After_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos récords personales`)
};

const pt_pt2_workout_after_records_title = /** @type {(inputs: Workout_After_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos recordes pessoais`)
};

const fr_fr2_workout_after_records_title = /** @type {(inputs: Workout_After_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveaux records personnels`)
};

const de_de2_workout_after_records_title = /** @type {(inputs: Workout_After_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Bestleistungen`)
};

const it_it2_workout_after_records_title = /** @type {(inputs: Workout_After_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovi record personali`)
};

/**
* | output |
* | --- |
* | "New personal bests" |
*
* @param {Workout_After_Records_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_records_title = /** @type {((inputs?: Workout_After_Records_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Records_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_records_title(inputs)
	if (locale === "es-419") return es_419_workout_after_records_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_records_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_records_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_records_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_records_title(inputs)
	return en_us2_workout_after_records_title(inputs)
});
export { workout_after_records_title as "workout-after.records_title" }